import * as actionType from "./Action_Type";
import { CALL_API } from "../Middlewares/api";
import { sortList } from "../Utils/Sorting";
import * as SGUri from "../Utils/PagesSwitch.js";
import { FIELD_GET_LIST, FIELD_ADD_MODIFY } from "../Utils/Strings/Service_Endpoint";
import { refreshList, requestList } from "./Action_Utils.js";

export function getCampiPersonalizzatiList(filter) {
  var obj = {
    Nome         : filter.Nome,
    Etichetta    : filter.Etichetta,
    IDTipo       : filter.IDTipo,
    Modificabile : filter.Modificabile,
    Obbligatorio : filter.Obbligatorio,
    Cancellato   : filter.Cancellato,
    IDHolding    : filter.IDHolding,
    IDTabella    : filter.IDTabella
  };

  return {
    [CALL_API]: {
      endpoint: FIELD_GET_LIST+SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_CAMPIPERSONALIZZATI_LIST_REQUEST,
        actionType.SERVICE_CAMPIPERSONALIZZATI_LIST_SUCCESS,
        actionType.SERVICE_CAMPIPERSONALIZZATI_LIST_ERROR
      ]
    }
  };
}

export function setCampoPersonalizzato(campo) {
  var obj = {
    ID                     : campo.ID,
    Nome                   : campo.Nome,
    Obbligatorio           : campo.Obbligatorio,
    LunghezzaUno           : campo.LunghezzaUno,
    LunghezzaDue           : campo.LunghezzaDue,
    Etichetta              : campo.Etichetta,
    ValoreDefault          : campo.ValoreDefault,
    ModificabileInPesata   : campo.ModificabileInPesata,
    IDMaster               : campo.IDMaster,
    Cancellato             : campo.Cancellato || false,
    Holding                : campo.Holding,
    TipoCampo              : campo.TipoCampo,
    IDTabellaSorgente      : campo.IDTabellaSorgente,
    IDColonna              : campo.IDColonna,
    IDTabella              : campo.IDTabella
  };
  return {
    [CALL_API]: {
      endpoint: FIELD_ADD_MODIFY,
      authenticated: true,
      types: [
        actionType.SERVICE_CAMPIPERSONALIZZATI_SET_REQUEST,
        actionType.SERVICE_CAMPIPERSONALIZZATI_SET_SUCCESS,
        actionType.SERVICE_CAMPIPERSONALIZZATI_SET_ERROR
      ],
      method : "POST",
      data   : SGUri.serializeParametersPOST(obj)
    }
  };
}

export const orderListaCampi = (holdList, value) => {
  return dispatch => {
     dispatch(requestList(actionType.SERVICE_CAMPIPERSONALIZZATI_LIST_REQUEST));
     dispatch(refreshList(sortList(holdList, value), actionType.SERVICE_CAMPIPERSONALIZZATI_REFRESH_LIST));
   }
}

export function getCampiTabellaList(filter) {
  var obj = {
    Nome         : filter.Nome,
    Etichetta    : filter.Etichetta,
    IDTipo       : filter.IDTipo,
    Modificabile : filter.Modificabile,
    Obbligatorio : filter.Obbligatorio,
    Cancellato   : filter.Cancellato,
    IDHolding    : filter.IDHolding,
    IDTabella    : filter.IDTabella
  };

  return {
    [CALL_API]: {
      endpoint: FIELD_GET_LIST+SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_CAMPITABELLA_LIST_REQUEST,
        actionType.SERVICE_CAMPITABELLA_LIST_SUCCESS,
        actionType.SERVICE_CAMPITABELLA_LIST_ERROR
      ]
    }
  };
}




// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Campi.js